/*
 *  This file is part of CoCalc: Copyright © 2021 Sagemath, Inc.
 *  License: MS-RSL – see LICENSE.md for details
 */

export const SERVER_SETTINGS_ENV_PREFIX = "COCALC_SETTING";
